import { makeVar, useReactiveVar } from '@apollo/client';

const eligibilityWidgetStore = makeVar({ pid: '', apiKey: '' });

/**
 * Do not call directly
 * Utilize @useEligibilityWidget custom hook
 */
export const useEligibilityWidgetStore = () => {
  const context = useReactiveVar(eligibilityWidgetStore);
  if (context === undefined) {
    throw new Error('useEligibilityWidgetStore must be used within an ApolloProvider');
  }
  return {
    states: {
      pid: context.pid,
      apiKey: context.apiKey,
    },
    actions: {
      setPid: (pid: string) => eligibilityWidgetStore({ ...eligibilityWidgetStore(), pid }),
      setApiKey: (apiKey: string) => eligibilityWidgetStore({ ...eligibilityWidgetStore(), apiKey }),
    },
  };
};

export default useEligibilityWidgetStore;
